export default __webpack_public_path__ + "static/media/learn-more-card-8.bd433b0a.svg";